import './Footer.css';
const Footer =()=>{
    return(
        <div className='footer'>
            <h6>A small service with localStorage developed by dac.dev</h6>
        </div>
    )
}
export default Footer;
